// MegaMenu web component (no Shadow DOM)
class MegaMenu extends HTMLElement {
  constructor() {
    super();
    this.header = null
  }

  connectedCallback() {
    this.header = this.closest("header")
    this.initMegaMenu();
  }

  initMegaMenu() {
    // Tab status logic
    function megaTabStatus(status, el) {
      let children = el.querySelectorAll('a,button');
      if (status == 'true') {
        children.forEach((child) => {
          child.setAttribute('tabindex', '-1');
        });
      } else {
        children.forEach((child) => {
          child.setAttribute('tabindex', '0');
        });
      }
    }

    let megaIndex = this.getAttribute('data-mega');
    
    if (megaIndex) {
        megaTabStatus('true', this);
        let indexOfMega = megaIndex
        let menuItem = this.header.querySelector(`[data-menu="${indexOfMega}"]`);
        if (menuItem) {
          let menuIcon = menuItem.querySelector('.dropdown-icon');
          let menuLink = menuItem.querySelector('.menu-link');
          let subMenu = menuItem.querySelector('.sub-menu');
          if (subMenu) {
            subMenu.classList.add('opacity-0');
            subMenu.classList.add('pointer-events-none');
            menuIcon.classList.add('mobile-icon');
          }
          menuIcon.classList.remove('hidden');
          menuIcon.classList.add('flex');
          menuLink.setAttribute('aria-controls', `${indexOfMega}-mega-item`);
          menuItem.addEventListener('mouseenter', (e) => {
            menuLink.setAttribute('aria-expanded', 'true');
            this.classList.add('mega-active');
            menuIcon.classList.add('rotate-icon');
          });
          menuItem.addEventListener('mouseleave', (e) => {
            menuLink.setAttribute('aria-expanded', 'false');
            this.classList.remove('mega-active');
            menuIcon.classList.remove('rotate-icon');
          });
          this.addEventListener('mouseenter', (e) => {
            menuIcon.classList.add('rotate-icon');
          });
          this.addEventListener('mouseleave', (e) => {
            menuIcon.classList.remove('rotate-icon');
          });
          menuLink.addEventListener('keyup', (e) => {
            if (e.key === 'ArrowDown') {
              menuLink.setAttribute('aria-expanded', 'true');
              this.classList.remove(`scale-y-0`);
              this.classList.remove(`opacity-0`);
              megaTabStatus('false', item);
            } else if (e.key === 'ArrowUp') {
              menuLink.setAttribute('aria-expanded', 'false');
              this.classList.add(`scale-y-0`);
              this.classList.add(`opacity-0`);
              megaTabStatus('true', item);
            }
          });
        }      
    }

    // Mega Links Open
    let menuItems = this.querySelectorAll('.mega-left .menu-item');
    if (menuItems) {
      menuItems.forEach((item) => {
        if (item.querySelector('.sub-menu')) {
          item.querySelector('.menu-link').addEventListener('click', (e) => {
            e.preventDefault();
            item.querySelector('.sub-menu').classList.remove('scale-x-0');
          });
          if (item.querySelector('.sub-menu2')) {
            let subMenuItem = item.querySelector('.sub-menu li');
            subMenuItem.addEventListener('click', (e) => {
              e.preventDefault();
              subMenuItem.querySelector('.sub-menu2').classList.remove('scale-x-0');
            });
          }
          item.querySelectorAll('.back').forEach((backBtn) => {
            backBtn.addEventListener('click', (e) => {
              item.querySelector('.sub-menu').classList.add('scale-x-0');
              if (item.querySelector('.sub-menu2')) {
                item.querySelector('.sub-menu2').classList.add('scale-x-0');
              }
            });
          });
        }
      });
    }
  }
}

if(!customElements.get('mega-menu')){
    customElements.define('mega-menu', MegaMenu);
}
